import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import CommonButton from '../components/atom/CommonButton';
import { useTranslation } from 'react-i18next';
import { editTransactionNote } from '@openapi/transactions/transactions';
import useNotify from '../hooks/useNotify';

const TransactionNoteEditModal = ({ transaction, onSuccess, showModal, MODAL_TYPE }) => {
    const { t } = useTranslation();
    const { notifySuccess, notifyError } = useNotify();
    const [note, setNote] = useState(transaction?.paymentInfo?.note || '');
    const [loading, setLoading] = useState(false);

    const closeAction = () => showModal(MODAL_TYPE.NONE);

    const handleSave = async () => {
        try {
            setLoading(true);
            await editTransactionNote(transaction.id, { note });
            notifySuccess(t('transactions.noteSaved'));
            if (onSuccess) onSuccess();
            closeAction();
        } catch (error) {
            notifyError(error?.response?.data?.message || t('errors.unknown'));
        } finally {
            setLoading(false);
        }
    };

    if (!transaction) {
        return null;
    }

    return (
        <Dialog open onClose={closeAction} maxWidth="xs" fullWidth>
            <DialogTitle>{t('transactions.editNoteTitle')}</DialogTitle>
            <DialogContent>
                <TextField
                    label={t('transactions.noteLabel')}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    multiline
                    fullWidth
                    autoFocus
                    margin="dense"
                    data-testid="transaction-note-field"
                />
            </DialogContent>
            <DialogActions>
                <CommonButton
                    buttonType="secondary"
                    onClick={closeAction}
                    disabled={loading}
                    label={t('common.cancel')}
                />
                <CommonButton
                    buttonType="primary"
                    onClick={handleSave}
                    disabled={loading}
                    label={t('common.save')}
                />
            </DialogActions>
        </Dialog>
    );
};

export default TransactionNoteEditModal;
